import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useFormikContext} from "formik";

import {fetchList} from "../../hook/axios.hook";
import ToolTip from "../../utilities/ToolTip";

import {SelectWithPagination} from "./SelectWithPagination";
import TextInput from "./TextInput";

export const formDeliveryPointFromPostCode = index =>
  index ? `${index?.address ? `${index.address}, ` : ""}${index?.city}, ${index?.district}, ${index?.region}` : "";

const IndexSelect = ({readOnly, countryId, currentIndex, currentProjectId}) => {
  const {t} = useTranslation();
  const {
    values,
    values: {deliveryPointIndex},
    setFieldValue,
  } = useFormikContext();

  const [indexes, setIndexes] = useState([]);

  useEffect(() => {
    setIndexes([]);
  }, [currentProjectId]);

  // useEffect(() => {
  //   console.log("uef");
  //   if (deliveryPointIndex === undefined && currentIndex && countryId) {
  //     console.log(
  //       "deliveryPointIndex === undefined && currentIndex && countryId :",
  //       deliveryPointIndex === undefined && currentIndex && countryId,
  //     );
  //     setFieldValue("deliveryPointIndex", currentIndex);
  //     fetchList(`references/postCodes/${countryId}`, "get", {
  //       params: {search: currentIndex},
  //     }).then(resp => {
  //       const currentPostCode = resp?.data?.[0];
  //       setFieldValue("deliveryPoint", formDeliveryPointFromPostCode(currentPostCode));
  //     });
  //   }
  // }, [deliveryPointIndex, currentIndex, countryId]);

  const doesIndexescontainCurrent = indexes?.find(({postCode}) => postCode === currentIndex);

  const indexOptionsRow = indexes?.map(({postCode, codeId}) => ({title: postCode, value: postCode, codeId})) ?? [];

  const indexOptions =
    !doesIndexescontainCurrent && currentIndex
      ? [...indexOptionsRow, {title: currentIndex, value: currentIndex}]
      : indexOptionsRow;

  const onIndexSelect = option => {
    if (!option || !option.value) return;
    const postCode = option.value;

    const currentIndex = indexes.find(index => index.postCode === postCode);
    const deliveryPoint = formDeliveryPointFromPostCode(currentIndex);
    setFieldValue("deliveryPoint", deliveryPoint);
  };

  const onFetchForOptions = ({page, changePage, search, countryId}) => {
    if (countryId) {
      fetchList(`references/postCodes/${countryId}`, "get", {
        params: {page: page.currentPage, ...(search ? {search} : {})},
      }).then(resp => {
        if (Array.isArray(resp.data)) {
          setIndexes(page.currentPage === 1 ? resp.data : [...indexes, ...resp.data]);
          changePage(resp);
        } else {
          setIndexes([]);
          changePage(1);
        }
      });
    }
  };

  return (
    <>
      <SelectWithPagination
        options={indexOptions}
        label="Delivery point index"
        name="deliveryPointIndex"
        autolabel
        readOnly={readOnly}
        makeEffect={onIndexSelect}
        onFetchForOptions={!deliveryPointIndex ? onFetchForOptions : () => {}}
        countryId={countryId}
        projectId={currentProjectId}
        width="6rem"
      />
      <ToolTip title={values?.deliveryPoint} className="fGrow">
        <TextInput label="Delivery point" name="deliveryPoint" autolabel readOnly={readOnly} />
      </ToolTip>
    </>
  );
};

export default IndexSelect;
